<!-- echarts -->
<template>
  <div :id="id" :style="{ width: '100%', height: `${height / 16}rem` }">sada</div>
</template>

<script>
export default {
  name: "",
  props: {
    id: {
      type: String,
      require: true,
    },
    height: {
      default: 200,
    },
    options: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    initCharts() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.getInstanceByDom(
        document.getElementById(this.id)
      );
      //防止图形变化重复渲染
      if (myChart == null) {
        myChart = this.$echarts.init(document.getElementById(this.id));
      }
      // 指定图表的配置项和数据
      myChart.setOption(this.options);
      myChart.off(); //防止多次点击图形
    },
  },
  computed: {},
  watch: {
    options: {
      handler(newVal) {
        this.$nextTick(() => {
          this.initCharts();
        });
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
